import { render, staticRenderFns } from "./GoodsConfigChoose.vue?vue&type=template&id=67b70a38&scoped=true"
import script from "./GoodsConfigChoose.vue?vue&type=script&lang=js"
export * from "./GoodsConfigChoose.vue?vue&type=script&lang=js"
import style0 from "./GoodsConfigChoose.vue?vue&type=style&index=0&id=67b70a38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b70a38",
  null
  
)

export default component.exports